/**
 * Samoan tālā.
 */
export var WST = {
  code: 'WST',
  base: 10,
  exponent: 2
};